import { useState } from 'react';
import { Button } from '../../components/Button';
import { VersionModal } from '../../components/VersionModal';
import { useStore } from '../../store/StoreProvider';
import { SettingsBlock } from './SettingsBlock';

// Impostazioni › Aiuto: la versione installata e le sue novità (lo stesso modale del tag in alto).
export function HelpTab() {
  const { state } = useStore();
  const [open, setOpen] = useState(false);
  return (
    <SettingsBlock
      over="Aiuto"
      title={`PopTown ${state.version}`}
      hint="La versione installata e le novità di ogni versione."
      control={
        <Button size="sm" icon="sparkles" onClick={() => setOpen(true)}>
          Novità delle versioni
        </Button>
      }
    >
      {open && <VersionModal onClose={() => setOpen(false)} />}
    </SettingsBlock>
  );
}
